import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { StoryGallery } from "@/components/site/StoryGallery";
import { STORY_SHORT } from "@/content/texts";

export const StoryBlock = () => (
  <section data-testid="story-section" aria-labelledby="story-title" className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
    <div className="max-w-2xl">
      <h2 id="story-title" className="font-serif-display text-[28px] sm:text-[40px] font-medium leading-tight">Nuestra historia</h2>
      <div className="mt-4 h-[2px] w-16 bg-[#B18A4B]" />
      <p className="mt-6 text-base sm:text-lg leading-[1.7] text-[#080808]/80">{STORY_SHORT}</p>
      <Link to="/nuestra-historia" data-testid="story-link" className="group mt-6 inline-flex items-center gap-2 text-[0.8rem] font-semibold uppercase tracking-[0.16em] text-[#080808] hover:text-[#B18A4B] transition-colors">
        Leer la historia completa <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
    <div className="mt-12"><StoryGallery testId="story-gallery" /></div>
  </section>
);
